import React, { useState } from 'react';
import { toast } from 'react-toastify';

import ConfirmModal from 'components/Modals/confirmModal';

export default function MakeWipTestImplModal({ closeModal }) {
  const [loading, setLoading] = useState(false);

  const makeWipTestImplIntoLive = () => {
    setLoading(true);
    // TODO Make the current wip into live here and update context or redirect
    setTimeout(() => setLoading(false), 1000);
    toast.error('Make current WIP the new live implementation Not Implemented!');
  };

  return (
    <ConfirmModal
      title="Confirmation"
      text="Do you want to make current WIP the live implementation?"
      onCancel={closeModal}
      onConfirm={makeWipTestImplIntoLive}
      loading={loading}
    />
  );
}
